import { signalsQuery } from "../lib/signalsQuery"
import { useDashboardQuery } from "./useDashboardQuery"

export function useGetSignals(props: Parameters<typeof signalsQuery>[0]) {
  return useDashboardQuery(signalsQuery(props))
}
